export default __webpack_public_path__ + "assets/eyeOpen.8ee16c5e.svg";